import { render } from "./list.vue?vue&type=template&id=5e04dc7a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=5e04dc7a&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e04dc7a"]])

export default __exports__